import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import arrowImage from "../../assets/images/vector.png";
import article1 from "../../assets/images/image1.png";
import article2 from "../../assets/images/Article-3.png";
import { ArrowUpRight } from "react-bootstrap-icons";
const ArticleCard = () => {
  const articles = [
    {
      image: article1 || "https://via.placeholder.com/400x300",
      title: "Vitamin B12: what you need to know",
      readTime: "5 min read",
      link: "https://myhealthchecked.com/articles/vitamin-b12-what-you-need-to-know",
    },
    {
      image: article2 || "https://via.placeholder.com/400x300",
      title: "B Vitamins: What you need to know and how to get enough",
      readTime: "7 min read",
      link: "https://myhealthchecked.com/articles/why-is-vitamin-b12-important",
    },
  ];

  return (
    <div className="container-fluid px-0">
      {articles.map((article) => (
        <a
          key={article.link}
          href={article.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Card
            className="mb-3 border-0 rounded-4 py-1 text-color-for-mhc"
            style={{ backgroundColor: "#fff", color: "#003032" }}
          >
            <Row className="g-2 align-items-center">
              <Col xs="auto">
                <Card.Img
                  src={article.image}
                  alt={article.title}
                  style={{
                    width: "148px",
                    height: "100px",
                    objectFit: "cover",
                    borderRadius: "10px",
                  }}
                />
              </Col>
              <Col>
                <Card.Body className="article-card-content" >
                  <Card.Title
                    className="text-color-for-mhc">
                    {article.title}
                  </Card.Title>
                  <Card.Text
                    className="mb-0 text-muted"
                  >
                    {article.readTime}
                  </Card.Text>
                </Card.Body>
              </Col>
              <Col className="justify-content-end d-flex">
                <div>
                  <img
                    src={arrowImage}
                    alt="arrow icon"
                    className="float-right custom-arrow"
                  />
                </div>
              </Col>
            </Row>
          </Card>
          <hr />
        </a>
      ))}
    </div>
  );
};

export default ArticleCard;
